import DataLayer from './gtm/DataLayer';

const helpfulDownloadsGA = () => {
  const downloadLinks = document.querySelectorAll('a.download-link');

  for (const downloadLink of downloadLinks) {
    downloadLink.addEventListener('click', function event() {
      DataLayer.sendAnalyticsEvent({
        category: 'Interaction',
        action: 'Button Click',
        label: `Download ${this.getAttribute('data-download-name')}`,
      });
    });
  }
};

export default helpfulDownloadsGA;
